'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var index = require('../../../../../../../node_modules/@radix-ui/react-dropdown-menu/dist/index.cjs');
var React = require('react');
var Icon_web = require('../../../atoms/Icon/Icon.web.cjs');
var Item_web_styles = require('./Item.web.styles.cjs');

/**
 * Subcomponent of Dropdown. Is a selectable item within a DropdownMenu.
 *
 * @scope Web
 */ const Item = ({ type = "default", icon, children, ...rest })=>{
    const itemStyles = React.useMemo(()=>[
            Item_web_styles.item,
            type === "destructive" && Item_web_styles.variants.danger
        ], [
        type
    ]);
    return /*#__PURE__*/ jsxRuntime.jsxs(index.Item, {
        css: itemStyles,
        ...rest,
        children: [
            /*#__PURE__*/ jsxRuntime.jsx("div", {
                css: Item_web_styles.iconContainer,
                children: icon && /*#__PURE__*/ jsxRuntime.jsx(Icon_web.Icon, {
                    intention: type === "destructive" ? "critical" : "neutral",
                    icon: icon,
                    size: "xsmall"
                })
            }),
            /*#__PURE__*/ jsxRuntime.jsx("div", {
                css: Item_web_styles.text.base,
                children: children
            })
        ]
    });
};
Item.displayName = "DropdownMenu.Item";

exports.Item = Item;
//# sourceMappingURL=Item.web.cjs.map
